import type { RecipientGift } from '@consumer/types/serializers'
import type { RedemptionDetailsForm } from '@consumer/stores/recipientV2'
import { injectionKey } from '@shared/injection'
import { useGift } from '@consumer/composables/gift'

const recipientLandingInjectionKey = injectionKey<ReturnType<typeof setupRecipientLanding>>('recipientLanding')

// `preview` is set by the admin greeting-card preview
// (Consumer::GreetingCardsController#preview), which renders this flow
// against an unsaved fake gift. The sub-pages read it to skip the
// `postOpenGift` round-trip that would otherwise hit the backend with a
// non-existent gift.
export function setupRecipientLanding (giftGetter: () => RecipientGift, { preview = false } = {}) {
  const gift = toRef(giftGetter)

  const api = {
    ...useGift(gift),
    gift,
    preview,
  }

  provide(recipientLandingInjectionKey, api)

  return api
}

export function useRecipientLanding () {
  return inject(recipientLandingInjectionKey)!
}

const redemptionDetailsInjectionKey = injectionKey<RedemptionDetailsForm>('redemptionDetails')

export function setupRedemptionDetails (form: RedemptionDetailsForm) {
  provide(redemptionDetailsInjectionKey, form)
}

export function useRedemptionDetails () {
  return inject(redemptionDetailsInjectionKey, { mailingAddress: {} } as RedemptionDetailsForm)!
}
